import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
export default function applyUpdatersToResults(results, result, updaters) {
  if (!updaters) return results;
  return _objectSpread(_objectSpread({}, results), Object.fromEntries(Object.entries(updaters).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        fetchKey = _ref2[0],
        updater = _ref2[1];

    return [fetchKey, updater(result, results[fetchKey])];
  })));
}